import { createApiAction } from '@app/packages/api/utils'
import type { ApiEmailConfirmation } from '@app/packages/api/v2/types/entities'

export const postEmailConfirmation = (token: string) =>
  createApiAction('postEmailConfirmation', dispatch =>
    dispatch<{ data: ApiEmailConfirmation }>({ method: 'POST', endpoint: '/api/v2/email_confirmation', body: JSON.stringify({ token }) })
  )

export const postEmailConfirmationResend = () =>
  createApiAction('postEmailConfirmationResend', dispatch => dispatch<unknown>({ method: 'POST', endpoint: '/api/v2/email_confirmation/resend' }))
